<template>
    <div class="container product-grid-report">
        <div class="row">
            <label class="client-shop-label">{{ clientShop }}</label>
        </div>
        <div class="row">
            <div class="section-row">
                <RouterLink to="/reports/grids/stores/progress" 
                    class="button-tab"
                    active-class="button-tab__selected">
                    <div class="button-tab-inner">Stores</div>
                </RouterLink>
                <RouterLink to="/reports/grids/keywords/comparison" 
                    class="button-tab"
                    active-class="button-tab__selected">
                    <div class="button-tab-inner">Keywords</div>
                </RouterLink>
            </div>
        </div>
        <router-view />
    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
    name: 'ProductGridReport',
    computed: {
        ...mapState('productGridReport', [
            'clientShop',
        ]),
    }
}
</script>

<style scoped lang="scss">
.container {
    display: flex;
    flex-direction: column;
    width: 90vw;
    margin: 0 auto;
}

.button-tab-inner {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 4px;
    margin-right: 4px;
    border-radius: 4px;
    transition: background-color 0.25s ease;
    height: 90%;
}

.button-tab {
    cursor: pointer;
    width: 200px;
    height: 100%;
    border: none;
    font-weight: 400;
    color: $rfx-light-march;
    text-decoration: none;
    
    &__selected {
        border-bottom: 2px solid $rfx-medium-march !important;
        font-weight: 700 !important;
        color: #fff !important;
        .button-tab-inner {
            background-color: $rfx-medium-march !important;
        }
    }
    &:hover .button-tab-inner {
        background-color: $rfx-light-steel;
    }
}

.section-row {
    border-bottom: 2px solid $rfx-light-steel;
    display: flex;
    flex-direction: row;
    height: 40px;
    width: 100%;
}

.row {
    display: flex;
    flex-direction: row;
}

.client-shop-label {
    font-size: 24px;
    font-weight: 600;
    color: $rfx-dark-march;
    margin: 32px 0;
}
</style> 